export default __webpack_public_path__ + "static/media/image04.835129ea.jpg";